module.exports = __webpack_public_path__ + "static/media/ss_1_en.ae36fbdf.jpg";